import { FC, Suspense, lazy } from "react";
import { TemplateType } from "@commons-monorepo/index";
import { HeaderProps } from "./types";

const Header2 = lazy(() => import("./skins/header-2/header-2"));
const Header3 = lazy(() => import("./skins/header-3/header-3"));

const MainHeader: FC<HeaderProps> = ({
  notFound,
  categories,
  hasWholesale,
  hasServices,
  hasOffers,
  theme,
  partnerId,
  ownerId,
  isPrime,
  data,
  isPortraitInView,
  goToCheckout,
  partnerWithPrivateDomain,
  t,
}) => {
  return (
    <Suspense>
      {theme?.template?.HEADER?.SKIN === TemplateType.HEADER_4 && (
        <Header2
          notFound={notFound}
          overBanner={!!theme?.template?.HEADER?.PROPS?.OVER_BANNER}
          sticky={!!theme.template.HEADER.PROPS.STICKY}
          categories={categories}
          hasOffers={hasOffers}
          hasServices={hasServices}
          hasWholesale={hasWholesale}
          partnerId={partnerId}
          ownerId={ownerId}
          isPrime={isPrime}
          theme={theme}
          data={data}
          partnerWithPrivateDomain={partnerWithPrivateDomain}
          isPortraitInView={isPortraitInView}
          t={t}
          goToCheckout={goToCheckout}
        />
      )}
      {theme?.template?.HEADER?.SKIN === TemplateType.HEADER_5 && (
        <Header3
          notFound={notFound}
          overBanner={!!theme?.template?.HEADER?.PROPS?.OVER_BANNER}
          sticky={!!theme?.template?.HEADER?.PROPS?.STICKY}
          categories={categories}
          hasOffers={hasOffers}
          hasServices={hasServices}
          hasWholesale={hasWholesale}
          partnerId={partnerId}
          ownerId={ownerId}
          isPrime={isPrime}
          theme={theme}
          data={data}
          partnerWithPrivateDomain={partnerWithPrivateDomain}
          isPortraitInView={isPortraitInView}
          t={t}
          goToCheckout={goToCheckout}
        />
      )}
    </Suspense>
  );
};

export default MainHeader;
